export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const socialMediaOptions = [
  {
    label: "",
    value: '',
  },
  {
    label: "Instagram",
    value: 'instagram_content_type',
  }
  , {
    label: 'Facebook',
    value: 'facebook_content_type'
  },
  {
    label: 'Youtube',
    value: 'youtube_content_type'
  }
]

export const socialMediaType = {
  instagram: "Followers",
  youtube: "Subscribers",
  facebook: "Likes",
  tiktok: "Followers",
  snapchat: "Subscribers"
};

export const landingImageUrl =
  "https://storage.googleapis.com/user-onboarding-data/onboarding_video/Landing-Image.jpg";

//Table Headers.

export const AccountsTableHeaders = [
  { label: 'Accounts Name', isSort: true, key: 'companyName' },
  { label: 'Admin', isSort: true, key: 'spoc' },
  { label: 'Accounts Mail ID', isSort: true, key: 'companyMailId' },
  { label: 'Phone Number', isSort: true, key: 'mobileNumber' },
  { label: 'Brands Created', isSort: true, key: 'brandCount' },
  { label: 'Campaigns Created', isSort: true, key: 'campaignCount' },
  { label: 'Account Creation Date', isSort: true, key: 'createdAt' },
  //Temporarily commenting this code
  // { label: 'Last Login Date', isSort: true, key: 'campaignCount' },
  { label: 'Notified For Fulfilment', isSort: true, key: 'campaignRequestCount' },
  { label: 'Account Status', isSort: true, key: 'status' },
]

export const campaignManagementHeaders = [
  { label: 'Deliverable ID' },
  { label: 'Deliverables' },
  { label: 'Deliverable Name' },
  { label: 'Final Creator Price' },
  { label: 'Final Brand Price' },
  { label: 'Social Commerce' },
  { label: 'Deliverable Approved' },
  { label: 'Expected Go Live Date' },
  { label: 'Post Link' },
  { label: 'Content Published' },
  { label: 'Content Published Date' },
  { label: 'Social Commerce Link' },
  { label: 'Payment Type' },
  // { label: 'Price Per Product' },
  { label: 'Commission Type' },
  { label: 'Commission Value (%)' },
  { label: 'Actions' },
]

//Other Constants
export const statusOptions = [
  { label: 'Shortlisted', value: 'Shortlisted' },
  { label: 'Negotiating', value: 'Negotiating' },
  { label: 'Confirmed', value: 'Confirmed' },
  { label: 'Dropped', value: 'Dropped' },
  { label: 'Content Published', value: 'Content Published' },
]

export const followersBadgeData = [
  {
    key: "total_followers",
    label: "Followers Total",
    type: "regularNumber"
  },
  {
    key: "authentic_followers",
    label: "Authentic followers",
    type: "percentage"
  },
  {
    key: "location",
    label: "Location"
  },
  {
    key: "average_views",
    label: "Avg. Play / reel",
    type: "regularNumber"
  }, {
    key: "average_engagements",
    label: "Avg. eng. / post",
    type: "regularNumber"
  }, {
    key: "engagement_rate",
    label: "Engagement rate",
    type: "percentage"
  },
]

export const platforms = ["instagram", "youtube", "facebook", "tiktok"]

export const audienceDataBadgeData = [
  {
    key: "authentic_followers",
    label: "Audience Credibility",
    type: "percentage"
  },
  {
    key: "likers_credibility",
    label: "Likers credibility",
    type: "percentage"
  },
  {
    key: "likes_from_non_followers",
    label: "Likes from non followers",
    type: "percentage"
  }]

// Earning Badge Data for Dashboard page
export const earningsBadgeData = [
  {
    key: "noOfOrder",
    label: "No. of orders",
  },
  {
    key: "totalSales",
    label: "Total Gross Sales",
    type: "rupee"
  },
  {
    key: "animetaCommision",
    label: "Animeta Commission",
    type: "rupee"
  }, {
    key: "totalCommission",
    label: "Total Commission",
    type: "rupee"
  }, {
    key: "avgOrderValue",
    label: "Avg Order Value",
    type: "rupee"
  }, {
    key: "creatorCommision",
    label: "Creator Commission",
    type: "rupee"
  },
]

// Earnings Page Cards key Values
export const Earningcards = [
  { key: "noOfOrder", label: "No. of orders" },
  { key: "totalSales", label: "Total Gross Sales", type: "rupee" },
  { key: "animetaCommision", label: "Animeta Commission", type: "rupee" },
  { key: "creatorCommision", label: "Creator Commission", type: "rupee" },
  { key: "totalCommission", label: "Total Commission", type: "rupee" },
  { key: "avgOrderValue", label: "Avg Order Value", type: "rupee" },
];

// Common Day
export const Days = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
}

// Common Months
export const Months = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
};